module.exports = __webpack_public_path__ + "media/images/gift-thanks-writer-bg-candy-1f4ae744cc5da9f95ac87f20f9e66706.png";